module.exports = __webpack_public_path__ + "static/media/3.cbe3a890.jpg";